var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTreoLock = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 99 99.96",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    x: 0,
    y: 0,
    width: 99,
    height: 99.96,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "uuid-79913a3f-07b0-4d18-be12-9d020334f7af"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 43.46,
    r: 43.46,
    style: {
      fill: "#fff",
      filter: "url(#drop-shadow-1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.47,67.97c-10.53,0-19.49-6.79-22.77-16.22-.61-1.76-2.25-2.95-4.11-2.95h-.04c-2.93,0-5.07,2.87-4.12,5.65,4.41,12.92,16.66,22.24,31.05,22.24,2.17,0,4.29-.22,6.33-.62,2.92-.58,4.42-3.85,2.93-6.42l-.03-.05c-.92-1.59-2.75-2.44-4.56-2.07-1.51.3-3.07.46-4.66.46h-.02Z",
    style: {
      fill: "#4e88a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.47,19.8c1.84,0,3.64.21,5.37.6,1.86.43,3.78-.39,4.73-2.04l.03-.06c1.44-2.49.11-5.71-2.69-6.36-2.39-.56-4.89-.85-7.45-.85-14.94,0-27.58,10.04-31.52,23.74-.8,2.79,1.25,5.58,4.15,5.58h.05c1.95,0,3.63-1.3,4.17-3.17,2.89-10.06,12.17-17.45,23.15-17.45h0Z",
    style: {
      fill: "#6ba543"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26,43.88c0-8.49-3.24-16.24-8.56-22.07-1.95-2.14-5.45-1.7-6.89.81v.02c-.97,1.66-.71,3.73.57,5.16,3.84,4.27,6.18,9.91,6.18,16.09s-2.55,12.3-6.68,16.63c-1.37,1.43-1.67,3.56-.68,5.28h0c1.43,2.48,4.85,2.93,6.83.88,5.71-5.9,9.24-13.93,9.24-22.78Z",
    style: {
      fill: "#eebf38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.43,39.98h-1.03v-4.02c0-3.49-2.83-6.33-6.33-6.33s-6.33,2.83-6.33,6.33v4.02h-1.03c-1.6,0-2.89,1.29-2.89,2.89v13.07c0,1.6,1.29,2.89,2.89,2.89h14.71c1.6,0,2.89-1.29,2.89-2.89v-13.07c0-1.6-1.29-2.89-2.89-2.89h0ZM49.05,53.04c-1.09,0-1.98-.89-1.98-1.98,0-.67.33-1.26.84-1.62-.02-.09-.03-.18-.03-.27v-2.81c0-.66.53-1.19,1.19-1.19s1.19.53,1.19,1.19v2.81c0,.1-.01.2-.04.3.49.36.8.94.8,1.59,0,1.09-.89,1.98-1.98,1.98h0ZM53.09,39.98h-8.04v-4.02c0-2.24,1.84-4.05,4.08-4.02,2.21.03,3.96,1.87,3.96,4.08v3.96Z",
    style: {
      fill: "#cccbcb"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTreoLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/treo_lock.f9d842cb.svg";
export { ForwardRef as ReactComponent };